<template>
  <v-bottom-sheet v-model="sheet" inset>
    <v-sheet class="pa-10">
      <v-form ref="ratingForm">
      <v-row>
        <v-col>
          How was your experience?
        </v-col>
        <v-btn tile large color="#5C658B" icon @click="sheet = false">
          <v-icon justify="end">mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-col justify="center" align="center">
        <v-img contain max-height="200" max-width="200" :src="logo"></v-img>
        <v-rating
          v-model="userRating"
          background-color="#FFAC4A"
          color="#FFAC4A"
          size="24"
          :rules="[rules.required]"
        ></v-rating>
      </v-col>
      <v-text-field
        placeholder="Say something about it?"
        v-model="userReview"
        outlined
      ></v-text-field>
      <v-row>
        <v-spacer />
        <v-col class="col-md-3">
          <v-btn
            color="indigo accent-3"
            @click="submitForm"
            :loading="ratingForm.loading"
            dark
            block
          >
            Submit
          </v-btn>
        </v-col>
      </v-row>
      </v-form>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
  import Keys from "../../../constants/keys";
  import { API_CLIENT_URL } from "../../../constants/urls";
  import Axios from "../../../api/BaseAxios";
  import store from "../../../store"
  import RULES from "../../../common/fieldRules";
  export default {
    name: "ResourceRating",
    props: ["id"],
    data() {
      return {
        logo: require("@/assets/EblityLogo.png"),
        userReview: null,
        userRating: 0,
        rules:RULES,
        ratingForm: {
          loading: false,
        },
      };
    },
    computed: {
      sheet: {
        get() {
          return this.$store.state.parentDashboard.showRatingSheet;
        },
        set(value) {
          store.dispatch("parentDashboard/updateShowRatingSheet", value);
        },
      },
    },
    methods: {
      submitForm() {
        let self = this;
        if(
        this.$refs.ratingForm.validate() &&
        !(
          this.userRating == 0 &&
          (this.userReview != null || this.userReview != "")
          )
        ){
        self.ratingForm.loading = true;
        let successHandler = (res) => {
          self.ratingForm.loading = false;
          self.sheet = false;
          console.log(res);
        };
        let failureHandler = (res) => {
          self.ratingForm.loading = false;
          self.sheet = false;
          console.log(res);
        };

        let requestParams = {};
        requestParams[Keys.RATING] = this.userRating;
        requestParams[Keys.REVIEW] = this.userReview;
        requestParams[Keys.ID] = this.id;

        Axios.request_POST(
          API_CLIENT_URL.reviewAdd,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
        }
        else{
          store.dispatch("snackBar/showToast", {
          message: "Please add a rating to this resource",
          color: "E",
        });
        }
      },
    },
  };
</script>

<style></style>
